import { Badge as ChakraBadge, BadgeProps } from '@chakra-ui/react'
import React from 'react'

export const Badge = React.forwardRef<HTMLDivElement, BadgeProps>(
  function Badge(props, ref) {
    const { variant = 'solid' } = props

    let backgroundColor: string | undefined = undefined
    let textColor: string | undefined = undefined
    let shadowColor: string | undefined = undefined
    switch (variant) {
      case 'solid':
        backgroundColor = 'colorPalette.500'
        break
      case 'subtle':
        backgroundColor = 'colorPalette.100'
        textColor = 'colorPalette.800'
        break
      case 'surface':
        break
      case 'outline':
        shadowColor = 'colors.colorPalette.500'
        textColor = 'colorPalette.600'
        break
    }

    return (
      <ChakraBadge
        ref={ref}
        bgColor={backgroundColor}
        color={textColor}
        borderRadius="sm"
        minH="20px"
        fontSize="xs"
        css={{
          '--shadow-color': shadowColor,
        }}
        {...props}
      />
    )
  },
)

interface NumberBadgeProps extends BadgeProps {
  children: string | number
}

export const NumberBadge = React.forwardRef<HTMLDivElement, NumberBadgeProps>(
  function NumberBadge(props, ref) {
    const { children, ...rest } = props

    // NOTE: 数値が2桁以上の場合はpaddingを小さくして円形の中に数値が収まるようにする
    const paddingInline = Number(children) > 9 ? '2px' : undefined

    return (
      <ChakraBadge
        ref={ref}
        borderRadius="full"
        paddingInline={paddingInline}
        {...rest}
      >
        {children}
      </ChakraBadge>
    )
  },
)
